import { render } from "./LeaveEntitlementReport.vue?vue&type=template&id=6ef58e5d&scoped=true"
import script from "./LeaveEntitlementReport.vue?vue&type=script&lang=js"
export * from "./LeaveEntitlementReport.vue?vue&type=script&lang=js"

import "./leave-entitlement-report.scss?vue&type=style&index=0&id=6ef58e5d&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ef58e5d"]])

export default __exports__